import IncludedList from "@/components/IncludedList";

const ACCOUNTS = ["Wise", "Yash Cash", "Nemik", "Pranay Cash", "Loan"];
const fields = [
  { key: "account", label: "Account", type: "select", options: ACCOUNTS.map((a) => ({ value: a, label: a })) },
  { key: "amount", label: "Amount", type: "decimal" },
  { key: "description", label: "Description", type: "text", optional: true },
  { key: "include_in_settlement", label: "Include in settlement", type: "switch" },
];

export default function MiscAccountsPage() {
  return (
    <div className="rise">
      <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight" data-testid="misc-title">Misc accounts &amp; loans</h1>
      <p className="mt-3 text-muted-foreground text-base md:text-lg">Balances held outside the ledger. A director's cash account counts for that director; Wise and Loan are split by share.</p>
      <IncludedList table="misc_balances" prefix="misc" singular="Balance" fields={fields}
        columns={[{ key: "account", label: "Account" }, { key: "description", label: "Description" }]}
        blank={{ account: "Wise", amount: "", description: "", include_in_settlement: false }}
        toBody={(f) => ({ account: f.account, amount: f.amount, description: f.description || "", include_in_settlement: !!f.include_in_settlement })}
        toForm={(r) => ({ ...r })} label={(r) => r.account} />
    </div>
  );
}
